/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { HikeType } from 'app/shared/model/enumerations/hike-type.model';
import { createEntity, getEntity, reset, updateEntity } from './doctor-charges.reducer';

export const DoctorChargesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const especialties = useAppSelector(state => state.especialty.entities);
  const doctorChargesEntity = useAppSelector(state => state.doctorCharges.entity);
  const loading = useAppSelector(state => state.doctorCharges.loading);
  const updating = useAppSelector(state => state.doctorCharges.updating);
  const updateSuccess = useAppSelector(state => state.doctorCharges.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);
  const hikeTypeValues = Object.keys(HikeType);

  const handleClose = () => {
    navigate(`/doctor-charges${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getHospitals({}));
    dispatch(getPaymentSchemes({}));
    dispatch(getEspecialties({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.consultationCharge !== undefined && typeof values.consultationCharge !== 'number') {
      values.consultationCharge = Number(values.consultationCharge);
    }
    if (values.followupCharge !== undefined && typeof values.followupCharge !== 'number') {
      values.followupCharge = Number(values.followupCharge);
    }
    if (values.followupDays !== undefined && typeof values.followupDays !== 'number') {
      values.followupDays = Number(values.followupDays);
    }
    if (values.followupVisits !== undefined && typeof values.followupVisits !== 'number') {
      values.followupVisits = Number(values.followupVisits);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.emergencyHike !== undefined && typeof values.emergencyHike !== 'number') {
      values.emergencyHike = Number(values.emergencyHike);
    }
    if (values.hishRiskHike !== undefined && typeof values.hishRiskHike !== 'number') {
      values.hishRiskHike = Number(values.hishRiskHike);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }

    const entity = {
      ...doctorChargesEntity,
      ...values,
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
      specialty: especialties.find(it => it.id.toString() === values.specialty?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          emergencyHikeType: 'PERCENTAGE',
          hishRiskHikeType: 'PERCENTAGE',
          ...doctorChargesEntity,
          doctor: doctorChargesEntity?.doctor?.id,
          hospital: doctorChargesEntity?.hospital?.id,
          scheme: doctorChargesEntity?.scheme?.id,
          specialty: doctorChargesEntity?.specialty?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.doctorCharges.home.createOrEditLabel" data-cy="DoctorChargesCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.doctorCharges.home.createOrEditLabel">Create or edit a DoctorCharges</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="doctor-charges-id"
                  label={translate('tinyMedicRestApp.doctorCharges.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.consultationCharge')}
                id="doctor-charges-consultationCharge"
                name="consultationCharge"
                data-cy="consultationCharge"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.followupCharge')}
                id="doctor-charges-followupCharge"
                name="followupCharge"
                data-cy="followupCharge"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.followupDays')}
                id="doctor-charges-followupDays"
                name="followupDays"
                data-cy="followupDays"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.followupVisits')}
                id="doctor-charges-followupVisits"
                name="followupVisits"
                data-cy="followupVisits"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.active')}
                id="doctor-charges-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.microSec')}
                id="doctor-charges-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.lastupdated')}
                id="doctor-charges-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.timestampentry')}
                id="doctor-charges-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.cursor')}
                id="doctor-charges-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.chargeType')}
                id="doctor-charges-chargeType"
                name="chargeType"
                data-cy="chargeType"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.addedByType')}
                id="doctor-charges-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.addedByID')}
                id="doctor-charges-addedByID"
                name="addedByID"
                data-cy="addedByID"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.modifiedByType')}
                id="doctor-charges-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.modifiedByID')}
                id="doctor-charges-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.emergencyHike')}
                id="doctor-charges-emergencyHike"
                name="emergencyHike"
                data-cy="emergencyHike"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.hishRiskHike')}
                id="doctor-charges-hishRiskHike"
                name="hishRiskHike"
                data-cy="hishRiskHike"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.emergencyHikeType')}
                id="doctor-charges-emergencyHikeType"
                name="emergencyHikeType"
                data-cy="emergencyHikeType"
                type="select"
              >
                {hikeTypeValues.map(hikeType => (
                  <option value={hikeType} key={hikeType}>
                    {translate(`tinyMedicRestApp.HikeType.${hikeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.hishRiskHikeType')}
                id="doctor-charges-hishRiskHikeType"
                name="hishRiskHikeType"
                data-cy="hishRiskHikeType"
                type="select"
              >
                {hikeTypeValues.map(hikeType => (
                  <option value={hikeType} key={hikeType}>
                    {translate(`tinyMedicRestApp.HikeType.${hikeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.multiplierApplied')}
                id="doctor-charges-multiplierApplied"
                name="multiplierApplied"
                data-cy="multiplierApplied"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.startDate')}
                id="doctor-charges-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.endDate')}
                id="doctor-charges-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.suspended')}
                id="doctor-charges-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorCharges.draft')}
                id="doctor-charges-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                id="doctor-charges-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.doctorCharges.doctor')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="doctor-charges-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.doctorCharges.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="doctor-charges-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.doctorCharges.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="doctor-charges-specialty"
                name="specialty"
                data-cy="specialty"
                label={translate('tinyMedicRestApp.doctorCharges.specialty')}
                type="select"
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/doctor-charges" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoctorChargesUpdate;
